const TYPES = ['slots'];

const isGameWithJackpot = (gameType: string): boolean => TYPES.includes(gameType);

export default isGameWithJackpot;
